import { Controller } from "@hotwired/stimulus"

// Keep the theme rail available beside desktop work, and folded above it on
// smaller screens. Native details remains usable before JavaScript connects.
export default class extends Controller {
  static values = { breakpoint: { type: Number, default: 1100 } }

  connect() {
    this.media = window.matchMedia(`(min-width: ${this.breakpointValue}px)`)
    this.sync = () => { this.element.open = this.media.matches }
    this.sync()
    this.element.dataset.responsiveDisclosureConnected = "true"
    this.media.addEventListener("change", this.sync)
  }

  disconnect() {
    this.media.removeEventListener("change", this.sync)
    delete this.element.dataset.responsiveDisclosureConnected
  }
}
